import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import './Event.css';
import logo from '../res/HazenLogo.png';

export class NavMenu extends Component {
  static displayName = NavMenu.name;

  constructor (props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
        collapsed: true,
        hidden: true
    };
  }

  toggleNavbar () {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  render () {
    return (
      <header>
        <Navbar className="navbar-expand-sm navbar-toggleable-sm border-bottom box-shadow mb-3 navbarcolor" dark>
          <Container>
            <NavbarBrand href="https://www.hazenandsawyer.com/" target="_blank" className="navbarcolor"> <img src={logo} alt="logo" width="101" height="30" /></NavbarBrand>
            <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
            <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
              <ul hidden={this.state.hidden} className="navbar-nav flex-grow">
                <NavItem>
                    <NavLink tag={Link} className="text-light" to="/">Home</NavLink>
                </NavItem>
                <NavItem>
                    <NavLink tag={Link} className="text-light" to="/regform/3d96097d-44db-40b8-9d1e-e0452636c456/cb186145-3c21-48d7-a0a2-afabb70ba75d">Attend</NavLink>
                </NavItem>
                <NavItem>
                    <NavLink tag={Link} className="text-light" to="/decform/cb186145-3c21-48d7-a0a2-afabb70ba75d">Not Attend</NavLink>
                </NavItem>
                <NavItem>
                    <NavLink tag={Link} className="text-light" to="/unsub/B92BDAC0-EB84-4D99-94D4-050F76A6D8BB">Unsubscribe</NavLink>
                </NavItem>
                <NavItem>
                    <NavLink tag={Link} className="text-light" to="/flyer/3738F85A-2EC7-4C45-972C-416398CBB805">Event Flyer</NavLink>
                </NavItem>
              </ul>
            </Collapse>
          </Container>
         </Navbar>
      </header>
    );
  }
}
